import {base} from './base';

export const simply = base
  .extend('simply')
  // Colors
  .property('primary.color', '#896D71')
  .property('primary.font', 'Varela')

  // border radius
  .property('border.radius', '0px')

  // Page
  .property('page.background.color', '#FFFFFF')

  // Text
  .property('text.font', 'Varela')
  .property('text.color', '#60574F')

  // Menu
  .property('menu.background.color', '#E0DFD9')
  .property('menu.text.font', 'Varela')
  .property('menu.text.color', '#60574F')
  .property('menu.text.transform', 'none')

  // Image
  .property(
    'image.default',
    'https://images.teemill.com/wmlrao5trtwujoo1wznskujaa6oyj1fqihxgi7kcepjpk3uw.jpeg'
  )

  // Buttons

  // Quote
  .property('quote.fullBackground.color', '#E0DFD9')

  // AnnouncementV2
  .property('announcement.v2.text.color', '#E0DFD9')
  .property('announcement.v2.background.color', '#896D71')

  // Newsletter
  .property('newsletter.text.color', '#E0DFD9')
  .property('newsletter.fullBackground.color', '#896D71')

  // Footer
  .property('footer.text.color', '#60574F')
  .property('footer.background.color', '#E0DFD9');
